import { CampanhaPedidoResgateResponse } from "domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse"
import { IPagedListResponse } from "../../global/pagedListResponse"
import ValidationResult from "../../global/validationResult"


export const CAMPANHA_PEDIDORESGATE_GET_BY_USUARIO = 'CAMPANHA_PEDIDORESGATE_GET_BY_USUARIO'
export const CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA = 'CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA'
export const CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA = 'CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA'
export const CAMPANHARESGATE_APROVAR = 'CAMPANHARESGATE_APROVAR'
export const CAMPANHARESGATE_REPROVAR = 'CAMPANHARESGATE_REPROVAR'
export const SET_RESGATES_PAGAR = 'SET_RESGATES_PAGAR'
export const RESET_RESGATES_PAGAR = 'RESET_RESGATES_PAGAR'
export const REMOVE_RESGATE = 'REMOVE_RESGATE'

export interface CampanhaPedidoResgateState {
  CampanhaPedidoResgateByCampanha: IPagedListResponse<CampanhaPedidoResgateResponse> | undefined,
  formData: CampanhaPedidoResgateResponse[];
  mudancaStatus: ValidationResult;
}
export interface CampanhaPedidoAprovadosResgateState {
  //CampanhaPedidoResgateByUsuario: IPagedListResponse<CampanhaPedidoResgateResponse> | undefined,
  CampanhaPedidoResgateAprovadosByCampanha: IPagedListResponse<CampanhaPedidoResgateResponse> | undefined,
}

export interface CampanhaPedidoResgateByUsuarioAction {
  type: typeof CAMPANHA_PEDIDORESGATE_GET_BY_USUARIO,
  payload: IPagedListResponse<CampanhaPedidoResgateResponse>
}

export interface CampanhaPedidoResgateByCampanhaAction {
  type: typeof CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA,
  payload: IPagedListResponse<CampanhaPedidoResgateResponse>
}
export interface CampanhaPedidoResgateAprovadosByCampanhaAction {
  type: typeof CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA,
  payload: IPagedListResponse<CampanhaPedidoResgateResponse>
}

export interface CampanhaResgateAprovarAction {
  type: typeof CAMPANHARESGATE_APROVAR,
  payload: ValidationResult
}

export interface CampanhaResgateReprovarAction {
  type: typeof CAMPANHARESGATE_REPROVAR,
  payload: ValidationResult
}

export interface CampanhaResgatePagarAction {
  type: typeof SET_RESGATES_PAGAR,
  payload: CampanhaPedidoResgateResponse[]
}

export interface ResetCampanhaResgatePagarAction {
  type: typeof RESET_RESGATES_PAGAR,
  payload: undefined
}

export interface CampanhaResgateRemoveAction {
  type: typeof REMOVE_RESGATE,
  payload: number
}

export type CampanhasActionTypes =
  CampanhaPedidoResgateByUsuarioAction |
  CampanhaPedidoResgateByCampanhaAction |
  CampanhaResgateAprovarAction |
  CampanhaResgateReprovarAction |
  CampanhaPedidoResgateAprovadosByCampanhaAction |
  CampanhaResgatePagarAction |
  CampanhaResgateRemoveAction |
  ResetCampanhaResgatePagarAction